<template>
    <div class="goodslistall" v-if="goodslist.length>0">
        <div class="goodsshow">
            <div  v-for="(goods,index) in goodslist" :key="index" >
                 <user-collection-info-item :iconon="iconon" :iconoff="iconoff" :goods="goods" :index="(index+1)%5" :itemright="(index+1)%5==0?'0':'29px'" @editgoods="editgoods"/> 
            </div>
            <div class="clear"></div>
        </div>
        <div class="page-box">
            <div class="pageshow" v-if="showpage&&total>pagesize">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="1"
                    :current-page.sync="currentPage"
                    :page-size="pagesize"
                    background
                    layout="prev, pager, next"
                    :total="total"
                >
                </el-pagination>
            </div>
            <div class="clear"></div>
        </div>
    </div> 
     <el-empty v-else :description="description" :image="emptyimg" :image-size="imagesize"></el-empty>     
</template>

<script>
import UserCollectionInfoItem from '../user/UserCollectionInfoItem.vue'
import { Message  } from 'element-ui';
import { mapGetters} from 'vuex';
export default {
  data(){
      return{
          goodslist:{},
          total:0,
          currentPage:1,
          ischeckd:"",
          
          
      }
  },
  props: {
    pagesize: {
      type: Number,
      default: 20
    },
    url:{
        type:String,
        default:"/user_collection"
    },
    iconon:{
        type:String,
        default:"el-icon-delete"
    },
    iconoff:{
        type:String,
        default:"el-icon-delete"
    },
    showpage:{
        type:Boolean,
        default:true
    },
    where:{
        type:Object,
        default:function(){
            return {}
        }
    },
    description:{
        type:String,
        default:"没有找到相应产品"
    },
    emptyimg:{
        type:String,
        default:"/static/404/goods.png"
    },
    imagesize:{
        type: Number,
        default:328
    }
  },
  components: { UserCollectionInfoItem },
  methods:{
        getgoodslist(){
        //重新获取数据
            var mwhere = {};
            mwhere.params={};
            if(this.where.cid2){
                mwhere.params.cid2 = this.where.cid2;
            }
            if(this.where.cid3){
                mwhere.params.cid3 = this.where.cid3;
            }
            mwhere.params.options = this.where.attr;
            mwhere.params.pageIndex = this.currentPage;;
            mwhere.params.brand_id = this.where.brand_id;
            mwhere.params.uid = this.UserId;

            if(this.where.brand_id!=undefined){
                    const res = this.$api.goods.getgoodslistbyclass(mwhere).then((res)=>{
                    //console.log(mwhere)
                    this.goodslist = res.data.datas.data
                    this.total=res.data.datas.total
                })
            }

           
        },
        handleSizeChange(){
        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.getgoodslist();
        },
        editgoods(goodsid){
            this.doeditgoods(goodsid);
            //this.$emit('editgoods',goodsid);

        },
        deletegoods(goodsid){//删除我的收藏
            var index=this.goodslist.findIndex((item)=>
                { 
                    if(item.id == goodsid){
                        return true;
                    }
                }           
            )
            this.goodslist.splice(index,1)
        },
        doeditgoods(goodsid){
             var index=this.goodslist.findIndex((item)=>
                { 
                    if(item.id == goodsid){
                        return true;
                    }
                }           
            )
            if((this.goodslist[index].store+1)%2==0&&false){
                this.$FUnitls.confirmInfo("确定吗",this.doeditgoodss,{'goodsid':goodsid,'index':index});
            }else{
                let params={};
                params.goodsid = goodsid;
                params.index = index;
                this.doeditgoodss(params)  //goodsid index
            }
                     
        },
        doeditgoodss(params){//收藏           
            let goodsid = params.goodsid;
            let index = params.index;


            this.$api.goods.getStoreAdd(goodsid,(this.goodslist[index].store+1)%2).then((res)=>{
                if(res.data.errno==0){
                    if(this.goodslist[index].store==1){        
                        this.$set(this.goodslist[index], 'store', 0)
                        this.$FUnitls.showInfo("取消收藏",'info') 
                    }else{
                        this.$set(this.goodslist[index], 'store', 1)
                        this.$FUnitls.showInfo("已收藏",'info') 
                    } 
                    
                }else{
                    var options={
                    message:res.data.errmsg,
                    }
                    Message.error(options)  
                }
                

            })    
        }
     
    },
    mounted(){
        this.getgoodslist();
    },
    watch:{
        where(val){
            //console.log(val)
            this.currentPage=1;
            this.getgoodslist();            
        }
    },
    computed: {
        ...mapGetters(['UserId'])
    }
}
</script>

<style  scoped>

    
    .goodsshow{
        padding:0 8px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/brand/BrandGoods.vue